import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { eliminarAtencionACliente, eliminarUsuarioAtencionACliente, obtenerEstadisticas } from '../../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck'
import { useDispatch, useSelector } from 'react-redux'
import estilos from './UsuariosComponent.module.css'
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { DataGrid,GridToolbarQuickFilter } from '@mui/x-data-grid';
import { v4 as uuidv4 } from 'uuid';
import Backdrop from '@mui/material/Backdrop';

function TablaCarteraComponent(props) {

    const dispatch = useDispatch()
    const rowsAsociado = props.rowsAsociado
    const columnsAsociado = props.columnsAsociado
    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                    textAlign: 'right'
                }}
            >
                {/*<GridToolbarFilterButton Title='Filtro'/>*/}
                <GridToolbarQuickFilter />
            </Box>
        );
    }
    return (
        <Fragment>
            <div className='row justify-content-center'>
                <div className='col-12 bg-white'>
                    <div style={{ height: 550, width: '100%' }}>
                        <DataGrid
                            rows={rowsAsociado}
                            columns={columnsAsociado}
                            components={{
                                Toolbar: QuickSearchToolbar,
                            }}
                            // checkboxSelection
                            // selectionModel={[rowsAsociado[0].id, rowsAsociado[2].id]}
                            // selectionModel={selectionModel}
                            pageSize={10}
                            rowsPerPageOptions={[10]}
                            // onSelectionModelChange={setSelectionModel}
                            sx={{
                                boxShadow: 0,
                                color: 'black',
                                border: 0,
                                '& .MuiDataGrid-cell': {
                                    display: 'block',
                                    position: 'relative',
                                    textAlign: 'center',
                                },
                            }}
                        />
                    </div>
                </div>
            </div>
            
            {/* {modalComponent()} */}
        </Fragment>
    );
};

export default withRouter(TablaCarteraComponent)